import { useEffect, useMemo } from 'react'
import { useThree } from '@react-three/fiber'
import type { ArenaDef } from './content'
import { WORLD_FORGE_COMPOSITIONS } from './generatedWorldForge'
import { SUPREME_GAME_ENGINES } from './SupremeGameEngines'
import { arenaCompositionPlan, type ArenaStructuralAuthority } from './arenaCompositionAuthority'

export type FightScenarioArchitectureSnapshot = {
  product: 'fight'
  scenarioId: string
  worldForgeBound: boolean
  structuralAuthority:ArenaStructuralAuthority
  structuralWriterCount:number
  supremeEngineCount: number
  engines: readonly string[]
  bound: boolean
}

export function buildFightScenarioArchitectureSnapshot(arena:ArenaDef):FightScenarioArchitectureSnapshot {
  const worldForgeBound=arena.id in WORLD_FORGE_COMPOSITIONS
  const composition=arenaCompositionPlan(arena.id)
  const engines=[composition.authority,...SUPREME_GAME_ENGINES.map(engine=>engine.id)] as const
  return {
    product:'fight',
    scenarioId:arena.id,
    worldForgeBound,
    structuralAuthority:composition.authority,
    structuralWriterCount:composition.structuralWriterCount,
    supremeEngineCount:SUPREME_GAME_ENGINES.length,
    engines,
    bound:composition.structuralWriterCount===1&&SUPREME_GAME_ENGINES.length===10,
  }
}

export function FightScenarioArchitectureRuntime({arena}:{arena:ArenaDef}){
  const {scene}=useThree()
  const snapshot=useMemo(()=>buildFightScenarioArchitectureSnapshot(arena),[arena])
  useEffect(()=>{
    scene.userData.inyronScenarioArchitecture=snapshot
    scene.userData.inyronScenarioArchitectureBound=snapshot.bound
    return()=>{
      if(scene.userData.inyronScenarioArchitecture===snapshot){
        delete scene.userData.inyronScenarioArchitecture
        delete scene.userData.inyronScenarioArchitectureBound
      }
    }
  },[scene,snapshot])
  return null
}
